// src/pages/Dashboard.js
import { Typography } from "@mui/material";
import React from "react";

const Dashboard = () => {
  return (
    <div className="p-4">
      <Typography component="h2" variant="h5" sx={{ mb: 2 }}>
        {/* หน้าแรก */}
      </Typography>
    </div>
  );
};

export default Dashboard;
